import { MenuListPopover } from "@/components/atoms/menuList";
import { CustomerContactMenuProps } from "./types";
import { Button, Text } from "@fluentui/react-components";
import { useStyle } from "./style";

export const CustomerContactMenu = (props: CustomerContactMenuProps) => {
	const { title, icon, menuHeader, items } = props;
	const classes = useStyle();

	return (
		<MenuListPopover
			closeOnScroll
			trigger={
				<Button
					title={title}
					shape="circular"
					appearance="subtle"
					icon={icon}
					className={classes.contactButton}
				/>
			}
			itemsHeader={[
				<Text weight={"semibold"} className={classes.contactMenuHeader}>
					{menuHeader}
				</Text>,
			]}
			items={items}
		/>
	);
};
